import { Component, inject, output } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { NxDropdownModule } from '@aposin/ng-aquila/dropdown';
import { NxFormfieldModule } from '@aposin/ng-aquila/formfield';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateModule } from '@ngx-translate/core';
import Cookies from 'js-cookie';

export const PREFERRED_LOB_COOKIE_NAME = 'lob';
export const PREFERRED_LOB_COOKIE_DURATION_IN_DAYS = 365;

@UntilDestroy()
@Component({
  selector: 'kyc-line-of-business-selector',
  templateUrl: './line-of-business-selector.component.html',
  imports: [TranslateModule, NxFormfieldModule, ReactiveFormsModule, NxDropdownModule],
})
export class LineOfBusinessSelectorComponent {
  private readonly router = inject(Router);

  public readonly lineOfBusinessEmitter = output<string>();

  protected readonly linesOfBusiness = [
    { code: 'tci', i18n: 'line-of-business.tci' },
    { code: 'surety', i18n: 'line-of-business.surety' },
    { code: 'fidelity', i18n: 'line-of-business.fidelity' },
  ];
  protected readonly lineOfBusinessControl = new FormBuilder().control('', Validators.required);

  constructor() {
    this.lineOfBusinessControl.valueChanges.pipe(untilDestroyed(this)).subscribe(async (lineOfBusiness) => {
      if (!lineOfBusiness) return;
      await this.router.navigateByUrl(`/${lineOfBusiness}`);
      this.lineOfBusinessEmitter.emit(lineOfBusiness);
      Cookies.set(PREFERRED_LOB_COOKIE_NAME, lineOfBusiness, {
        expires: PREFERRED_LOB_COOKIE_DURATION_IN_DAYS,
      });
    });
    this.router.events.pipe(untilDestroyed(this)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.setLineOfBusiness(event.urlAfterRedirects);
      }
    });
  }

  private setLineOfBusiness(url: string): void {
    const segments = new URL(`https://fakehost${url}`).pathname.split('/').filter(Boolean);
    const lineOfBusiness = segments[0];
    if (!lineOfBusiness && this.lineOfBusinessControl.value) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.router.navigateByUrl(`/${this.lineOfBusinessControl.value}`);
      return;
    }
    this.lineOfBusinessControl.patchValue(lineOfBusiness, { emitEvent: false });
  }
}
